jQuery(function () {

    window.ppComponents.radioGroup = {
        init: ($items) => {
            $items.each((index, item) => {
                let $item = $(item);
                if($item.data('radio-group-initialized'))
                    return;
                let group = $item.data('radio-group');
                if(!group)
                    return;
                $item.on('change',function(){
                    $(`[data-radio-group='${group}']`).prop('checked', false);
                    $item.prop('checked', true);
                });
                $item.data('radio-group-initialized', true);
            });
        }
    }

    $("[data-radio-group]").each((index, item) => {
        let $item = $(item);
        window.ppComponents.radioGroup.init($item);
    });
});